import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import loadable from '@loadable/component'

import { NO_DATA_MESSAGE } from '../../../utils/constants'
import AsOfDate from '../../AsOfDate'
import AnnualizedTotalReturns from './AnnualizedTotalReturns'

const LoadableTotalReturnsPerformance = loadable(
  () => import('./TotalReturnsPerformance'),
  {
    ssr: false,
    fallback: (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="200px"
      >
        <Typography variant="body1">Loading Performance Data...</Typography>
      </Box>
    ),
  }
)

const DateContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
}))

const NoDataMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: theme.typography.body2.fontSize,
  textAlign: 'center',
  margin: theme.spacing(4, 0),
}))

const TotalReturnsWrapper = ({
  data,
  fundClass = {},
  title = '',
  productType = '',
  fundTitle,
}) => {
  const isFundReturn = !!data?.performance?.fundReturn

  const returns =
    get(data, isFundReturn ? 'performance.fundReturn' : 'performance') || {}

  const showNoDataMessage = !Object.values(returns).some(Boolean)

  if (showNoDataMessage) {
    return <NoDataMessage>{NO_DATA_MESSAGE}</NoDataMessage>
  }

  const performanceData = {
    ...data,
    name: data.name || `${fundTitle} - Total Return`,
    performance: {
      ...(isFundReturn ? data.performance : {}),
      fundReturn: returns,
      isFundReturn,
    },
    performanceInceptionDate:
      data.performanceInceptionDate || data.performance_inception_date,
  }

  const performanceProps = {
    ...performanceData,
    title,
  }

  return (
    <>
      {!isFundReturn &&
        get(performanceData, 'performance.fundReturn.calendar.date') && (
          <DateContainer>
            <AsOfDate
              date={get(
                performanceData,
                'performance.fundReturn.calendar.date'
              )}
            />
          </DateContainer>
        )}

      {isFundReturn && (
        <LoadableTotalReturnsPerformance {...performanceProps} />
      )}

      <AnnualizedTotalReturns
        {...performanceData}
        expense_ratio={get(fundClass, 'expense_ratio', 'N/A')}
        productType={productType}
      />
    </>
  )
}

TotalReturnsWrapper.propTypes = {
  data: PropTypes.any,
  fundClass: PropTypes.any,
  title: PropTypes.string,
  productType: PropTypes.string,
  fundTitle: PropTypes.string,
}

export default TotalReturnsWrapper